import { getLabelMessage } from '@gef-ui/localization/messages';

import SectionHeader from 'components/atoms/GefMui/SectionHeader';

export const Toolbar = () => {
	return <SectionHeader text={getLabelMessage('semaphore:filterTitle')} />;
};

export default Toolbar;
